module.exports = __webpack_public_path__ + "img/af0dc4a98e7c1f9cc1da441ac6c0465c.png";